var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAngleRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 16,
    viewBox: "0 0 11 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.85235 9.03802L2.28784 15.6559C1.39644 16.4369 5.0739e-07 15.8022 5.0739e-07 14.6169V1.38106C-0.000226934 1.11579 0.0760146 0.856073 0.219595 0.633015C0.363176 0.409956 0.56801 0.233013 0.809566 0.123373C1.05112 0.0137337 1.31916 -0.0239541 1.58159 0.014823C1.84401 0.0536002 2.0897 0.167198 2.28922 0.342014L9.85097 6.95992C9.99918 7.08944 10.118 7.24916 10.1994 7.42838C10.2807 7.60759 10.3229 7.80214 10.3229 7.99897C10.3229 8.1958 10.2807 8.39035 10.1994 8.56956C10.118 8.74878 9.99918 8.9085 9.85097 9.03802H9.85235Z",
    fill: "#EFC319"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngleRight);
export default __webpack_public_path__ + "static/media/angle-right.d6a8deec7e42ffdd53ceaa18ae2e8a5b.svg";
export { ForwardRef as ReactComponent };